<template>
   <div></div>
</template>

<script>
import {debounce} from "../../utlis/utlis";
// import {recipeInfo} from "../../js/recipe";
import { Loading } from 'element-ui';

export default {
  name: "RecipeCopy",
  data() {
    return {
      stepActive: 0,
      api: {
        detail: this.$api.recipe.detail,
        update: this.$api.recipe.update,
        save: this.$api.recipe.copy,
      },
      formData: {},
      load: false,
      code: ''
    }

  },
  methods: {
    copy(params){
      this.handleGetDetail(params);
    },
    handleGetDetail(params) {
      const vm = this;
      this.loading = Loading.service({text:`${this.$t('lang.正在复制中')}...`,background:'rgba(0,0,0,0.1)'});
      vm.$http.get(vm.api.detail, {params: params}).then(res => {
        if(res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        let data = res.data.data['recipe'];
        this.handleSave(data)
      })

    },

    handleSave: debounce(function (data) {
      const vm = this;
      // let data = this.handleFilterData();
      console.log('过滤后的数据', data);
      vm.$http.post(vm.api.save, data).then(res => {
        console.log("保存请求", res);
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$message.success(this.$t('lang.复制成功'));
        vm.$emit('finish');
        this.loading.close();
      }).catch(() => {
        this.loading.close();
      });
    }, 3000, true),


    handleSetDataStorage() {
      let formData = window.localStorage.getItem("recipeDataCopy");
      let data = this.formData;
      window.localStorage.setItem("error", JSON.stringify(this.formData));
      if (formData) {
        data = Object.assign(JSON.parse(formData), this.formData);
      }
      window.localStorage.setItem("recipeDataCopy", JSON.stringify(data));
    },

    handleFilterData() {
      const vm = this;
      let formData = window.localStorage.getItem("recipeDataCopy");
      if (!formData) {
        vm.$message.error(this.$t('lang.请填写完信息再提交'));
        return;
      }
      let data = JSON.parse(formData);

     /* // 处理步骤一
      data["brandOwnerCode"] = vm.$store.state.userInfo["brandOwnerCode"];
      let supportLangList = [];
      data["supportLangList"].forEach(item => {
        supportLangList.push(item.value);
      });
      data["supportLangList"] = supportLangList;
      delete data["autoCreate"];

      // 处理步骤二
      if (data["portionSizeList"] && data["portionSizeList"].length) {
        data.portionSizeList.forEach((item, index) => {
          item["number"] = index + 1 + "";
          delete item.langCurrent;
          item.foods = item.foods.map((food, idx) => {
            food.number = idx + 1 + "";
            delete food.langCurrent;
            for (const fKey in food) {
              if(food[fKey] instanceof Object) {
                food[fKey].amount = Number(food[fKey].amount);
              }


              if (food[fKey] instanceof Object && !food[fKey].foodName) {
                delete food[fKey];
              }
            }
            return food;
          });
        });
      }

      // 处理步骤 四
      if (data["cookingStepList"] && data["cookingStepList"].length) {
        data.cookingStepList.forEach(item => {
          item["number"] = item["number"] + "";
          delete item.langCurrent;
        });
      }

      // 处理步骤五
      if(data["nutritionList"] && data["nutritionList"].length) {
        data["nutritionList"].forEach(item => {
          item["number"] = item["number"] + "";
          delete item['langCurrent'];
          for (const key in item) {
            if(item[key] instanceof Object) {
              item[key].amount = Number(item[key].amount);
            }

            if (item[key] instanceof Object && !item[key].nutritionName) {
              delete item[key];
            }
          }
        });
      }*/

      data['code'] = this.$route.query.code;

      return data;

    }
  },
  created() {

  }
}
</script>

<style scoped>

</style>
